// Better Auth React client (T04 §9.5). Same origin in the single container; the Vite dev proxy forwards
// /api to :3000, so no base URL is hardcoded. adminClient/twoFactorClient add `role` and `twoFactorEnabled`
// to the inferred user type, so no type import from the server is needed (dependency direction, C06).
import { createAuthClient } from "better-auth/react";
import { adminClient, twoFactorClient } from "better-auth/client/plugins";
import { ac, roles } from "@chartvn/schema/permissions";

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: "/api/auth",
  fetchOptions: { credentials: "include" },
  plugins: [adminClient({ ac, roles }), twoFactorClient({ twoFactorPage: "/two-factor" })],
});

export const { useSession } = authClient;
